/**
 * Merge a vocal preset patch into the app's track.effects object (deep merge for nested objects).
 * Does not remove existing keys — only overwrites what the preset defines. Users can keep editing.
 */
export function mergeVocalPresetIntoTrackEffects(baseEffects, preset) {
  const base = baseEffects && typeof baseEffects === 'object' ? { ...baseEffects } : {};
  const patch = preset?.patch && typeof preset.patch === 'object' ? preset.patch : {};

  const deepMerge = (a, b) => {
    const out = { ...a };
    for (const key of Object.keys(b)) {
      const bv = b[key];
      const av = a[key];
      if (
        bv &&
        typeof bv === 'object' &&
        !Array.isArray(bv) &&
        av &&
        typeof av === 'object' &&
        !Array.isArray(av)
      ) {
        out[key] = deepMerge(av, bv);
      } else {
        out[key] = bv;
      }
    }
    return out;
  };

  return deepMerge(base, patch);
}

/**
 * @param {object} track - track with .effects
 * @param {object} preset - { id, patch }
 * @returns {{ effects: object, vocalPresetId: string }}
 */
export function loadVocalPreset(track, preset) {
  if (!track || !preset?.id) {
    return { effects: track?.effects || {}, vocalPresetId: null };
  }
  const effects = mergeVocalPresetIntoTrackEffects(track.effects, preset);
  return { effects, vocalPresetId: preset.id };
}
